<template>
  <div class="sidebar-box">
    <div class="theme-wrap" @click="switchTheme" :class="[theme]" v-if="isHome">
      <div class="inner">
        <div class="inner-bg"></div>

        <div class="icon-wrap">
          <svg class="light-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.27344 4.09082L4.0098 4.82718" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M1.63672 9H2.4549" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M3.27344 13.8272L4.0098 13.0908" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M14.6465 13.8272L13.9102 13.0908" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M16.3651 9H15.5469" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M14.6465 4.09082L13.9102 4.82718" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M9 1.63672V2.4549" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M9.00107 13.091C11.2604 13.091 13.092 11.2594 13.092 9.00009C13.092 6.74075 11.2604 4.90918 9.00107 4.90918C6.74172 4.90918 4.91016 6.74075 4.91016 9.00009C4.91016 11.2594 6.74172 13.091 9.00107 13.091Z" fill="currentColor" stroke="currentColor" stroke-width="0.818182" stroke-linejoin="round"/>
            <path d="M9 16.3641V15.5459" stroke="currentColor" stroke-width="1.63636" stroke-linecap="square" stroke-linejoin="round"/>
          </svg>
        </div>

        <div class="icon-wrap">
          <svg class="dark-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.4925 1.78799C8.47857 2.31305 6.99211 4.14426 6.99211 6.32268C6.99211 8.91067 9.09004 11.0086 11.678 11.0086C13.8565 11.0086 15.6877 9.52214 16.2127 7.50822C16.3119 7.99006 16.364 8.48913 16.364 9.00036C16.364 13.0672 13.0672 16.364 9.00036 16.364C4.93353 16.364 1.63672 13.0672 1.63672 9.00036C1.63672 4.93353 4.93353 1.63672 9.00036 1.63672C9.51158 1.63672 10.0106 1.68881 10.4925 1.78799Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>

    <div class="support-wrap" @click="openZendesk">
      <div>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9974 1.16377C10.3052 0.696679 9.16373 0.251218 8.26983 0.0955219C7.87559 0.0263243 6.63329 -0.0255737 6.34449 0.0133495C5.00592 0.19067 4.02492 0.528008 3.08059 1.12917C1.58616 2.07631 0.550144 3.52947 0.12382 5.27672C0.0321371 5.64866 0.0229688 5.81733 0.00921643 7.92355C-0.00912011 9.93462 -0.00453611 10.2028 0.0642259 10.445C0.215502 10.9726 0.637243 11.4224 1.21026 11.6732C1.40279 11.7554 1.5174 11.7684 1.94831 11.7727C2.43881 11.7727 2.46173 11.7684 2.80095 11.6083C3.38314 11.3402 3.77279 10.8558 3.88739 10.2633C3.95157 9.93894 3.95616 7.69433 3.89198 7.37861C3.78196 6.82503 3.36022 6.29739 2.82388 6.05088C2.36088 5.83463 1.93914 5.80436 1.32028 5.93843L1.20109 5.96438L1.24235 5.70921C1.30653 5.2897 1.50364 4.70152 1.7191 4.27335C2.57175 2.56935 4.26329 1.39731 6.21614 1.15079C6.77082 1.08159 7.83892 1.12484 8.31567 1.23729C9.40669 1.49246 10.3098 1.95522 11.0707 2.65152C11.9646 3.47325 12.6064 4.62367 12.776 5.70921L12.8173 5.96438L12.6752 5.9341C11.8134 5.76543 11.2862 5.88221 10.7315 6.36659C10.1631 6.86395 10.0806 7.16669 10.0806 8.81447C10.0806 10.1292 10.1081 10.3498 10.3098 10.739C10.4748 11.0591 10.9332 11.4829 11.2449 11.604L11.4558 11.6862V12.11C11.4558 12.3754 11.4558 12.4729 11.4164 12.5503C11.3934 12.5953 11.3572 12.6335 11.2999 12.6939L11.1441 12.8539L9.38377 12.8755C7.80225 12.8928 7.60971 12.9058 7.49969 12.975C7.11004 13.2172 7.11463 13.7189 7.51803 13.9222C7.66014 13.9914 7.81142 14 9.3471 14C11.1945 14 11.3825 13.9784 11.7767 13.7405C12.3772 13.3772 12.6477 12.8712 12.6477 12.1144V11.7121L12.9456 11.5737C13.317 11.4007 13.6608 11.0591 13.8579 10.6698C13.9513 10.485 14 10.2808 14 10.0737V8.05329C14 5.79571 13.9954 5.70489 13.8991 5.29402C13.482 3.55975 12.5147 2.18444 10.9974 1.16377ZM11.7589 7.02893C11.5479 7.12408 11.3966 7.2668 11.3278 7.43979C11.2957 7.51764 11.2773 8.03663 11.2773 8.82808C11.2773 10.052 11.2819 10.0953 11.3828 10.2812C11.6259 10.7353 12.3138 10.8089 12.6669 10.4153C12.8687 10.1861 12.8916 10.0217 12.8733 8.70698L12.8595 7.48304L12.7357 7.30572C12.5156 6.99433 12.1028 6.87756 11.7589 7.02893ZM1.6174 7.03434C1.49816 7.08624 1.37893 7.18571 1.29638 7.30248L1.16797 7.48845V8.80754C1.16797 10.0661 1.17255 10.1396 1.26428 10.2823C1.51651 10.6932 2.09435 10.7927 2.46123 10.4856C2.74098 10.252 2.75015 10.2088 2.75015 8.81186C2.75015 7.4452 2.74098 7.38033 2.49333 7.15976C2.2411 6.93919 1.94301 6.89594 1.6174 7.03434Z" fill="white"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  computed: {
    isHome() {
      return this.$route.path === '/';
    }
  },
  methods: {
    ...mapMutations(['switchTheme']),
    openZendesk() {
      if (window.zE) {
        zE('messenger', 'open');
        zE('messenger', 'show');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-box {
  position: fixed;
  inset-inline-end: 0.4rem;
  bottom: 0.74rem;
  z-index: $sidebar-box-index;

  .theme-wrap {
    background-color: #fff;
    padding: 0.04rem;
    border-radius: 0.3rem;
    margin-bottom: 0.2rem;
    box-shadow: 0px 0.04rem 0.08rem 0 #{rgba($main-color, 0.4)};
    cursor: pointer;

    .inner {
      padding: 0.02rem;
      background-color: $gray-F7;
      border-radius: 0.3rem;
      position: relative;
      height: 0.72rem;

      .icon-wrap {
        width: 0.32rem;
        height: 0.32rem;
        @include flex(center);

        &:last-of-type {
          margin-top: 0.04rem;
        }
      }

      .light-icon {
        color: $white;
        z-index: 1;
        width: 0.18rem;
        height: 0.18rem;
      }

      .dark-icon {
        color: $gray-light;
        z-index: 1;
        width: 0.18rem;
        height: 0.18rem;
      }

      &-bg {
        position: absolute;
        top: 0.02rem;
        width: 0.32rem;
        height: 0.32rem;
        background-color: $main-color;
        border-radius: 50%;
        transition: all .2s;
      }
    }

    &.dark {
      .light-icon {
        color: $gray-light;
      }

      .dark-icon {
        color: $white;
      }

      .inner {
        &-bg {
          top: 0.38rem;
        }
      }
    }
  }

  .support-wrap {
    border-radius: 50% 0 50% 50%;
    width: 0.44rem;
    height: 0.44rem;
    background-color: #fff;
    box-shadow: 0px 0.04rem 0.08rem 0 #{rgba($main-color, 0.4)};
    cursor: pointer;
    @include flex(center);
    padding: 0.08rem;
    cursor: pointer;

    div {
      width: 0.28rem;
      height: 0.28rem;
      background-color: $main-color;
      border-radius: 50%;
      @include flex(center);
    }

    svg {
      width: 0.14rem;
      height: 0.14rem;
    }
  }
}
</style>